import { captureMessage } from "@/helpers/sentry.js";
const YA_COUNTER = "90082538";

export const ymGoal = (goal) => {
  try {
    ym(YA_COUNTER, "reachGoal", goal);
  } catch (err) {
    captureMessage(`ymGoal error ${err}`);
  }
};

export const ymHit = (path) => {
  try {
    ym(YA_COUNTER, "hit", path);
  } catch (err) {
    captureMessage(`ymHit error ${err}`);
  }
};

export default ymGoal;
